import React from 'react';
import {makeStyles} from "@material-ui/core/styles/index";
import Search from "./Search";
import BrowseBodyType from "./BrowseBodyType";
import BrowseByMake from "./BrowseByMake";
import PopularCars from "./PopularCars";

const useStyles = makeStyles((theme) => {
    return {
        root: {
            width: '100%'
        },
        wrapper: {
            width: '100%',
            display: 'flex',
            alignContent: 'flex-start',
            flexWrap: 'wrap',
            boxSizing: 'border-box',
            flex: '0 0 100%',
        },
    }}
);

export default function MainPage(props) {
    const classes = useStyles();

    return (
        <>
            <div className={classes.wrapper}>
                <div className={classes.root}>
                    <Search isMobile={props.isMobile}/>
                    <BrowseByMake screenWidth={props.screenWidth}/>
                    <PopularCars screenWidth={props.screenWidth}/>
                </div>
            </div>
        </>
    );
}
